import { render } from "./ReferralSpecificInformation.vue?vue&type=template&id=178a4fdb&scoped=true"
import script from "./ReferralSpecificInformation.vue?vue&type=script&lang=js"
export * from "./ReferralSpecificInformation.vue?vue&type=script&lang=js"

import "./ReferralSpecificInformation.vue?vue&type=style&index=0&id=178a4fdb&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-178a4fdb"]])

export default __exports__
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBanner,QInput});
